import React, { useContext, useState } from 'react';
import { getWebsiteBaseUrl, getLang } from './../../shared/utils/environment.js';
import { ask__ } from './../../shared/utils/i18n.js';
import { getGoogleAnalyticsAcccount } from './../../shared/utils/analytics.js';
import ReactGA from 'react-ga';

import Register from '../Register/Register.jsx';

import { GlobalIsRegisteredContext } from '../../shared/context/GlobalIsRegistered.js';
import { GlobalUserContext } from '../../shared/context/GlobalUserContext.js';

import './Login.scss';

export default function Login(props) {

  const loginUrl = getWebsiteBaseUrl() + '/authorization?lang=' + getLang() + '&return=' + window.top.location.href + '#orton-booking';

  const {getGlobalIsRegistered, setGlobalIsRegistered} = useContext(GlobalIsRegisteredContext);
  const {getGlobalUser, setGlobalUser} = useContext(GlobalUserContext);

  const [isLoading, setIsLoading] = useState(false);
  const [acceptTermsAndConditions, setAcceptTermsAndConditions] = useState(false);

  const title = props.type == 'confirmation' ? ask__('Confirmation: Login title') : ask__('Login: Title');
  const desc = props.type == 'confirmation' ? ask__('Confirmation: Login desc') : ask__('Login: Description');

  return (
    <div className="login">

      {!getGlobalUser.isLoggedIn && !getGlobalIsRegistered ? <>

        <div className="login__auth">

          <h2>{title}</h2>
          <p dangerouslySetInnerHTML={{__html: (desc || '')}}></p>
          <div className="login__terms">
            <label for="accept-terms">
              <input
                id="accept-terms"
                name="accept-terms"
                type="checkbox"
                checked={acceptTermsAndConditions}
                onChange={e => setAcceptTermsAndConditions(e.target.checked)}
              />
              <span>
                {ask__('Login: Terms before') + ' '}
                <a
                  href={ask__('Login: Terms and conditions url')}
                  target="_blank"
                >
                  {ask__('Login: Terms and conditions')}
                </a>
              </span>

            </label>
          </div>
          <a
            className={acceptTermsAndConditions && !isLoading ? 'login__button' : 'login__button login__button--disabled'}
            target="_parent" href={acceptTermsAndConditions ? loginUrl : '#'}
            onClick={e => {
              if (acceptTermsAndConditions) {
                e.preventDefault();
                setIsLoading(true);
                try {
                  // track Google Analytics
                  ReactGA.initialize(getGoogleAnalyticsAcccount());
                  ReactGA.event({
                    category: 'Nettiajanvaraus',
                    action: 'Tunnistautuminen',
                    label: 'Siirry tunnistautumiseen'
                  });
                  console.log('Tracking: Login tracked.');
                  setTimeout(() => {
                    window.top.location = loginUrl;
                  }, 1250);
                } catch(err) {
                  window.top.location = loginUrl;
                }
              }
            }}
          >
            { ask__('Login: Button') }
          </a>

        </div>

      </> : ''}

      {getGlobalUser.isLoggedIn && !getGlobalIsRegistered ? <>

        <div className="login__register">
          <Register type="new" />
        </div>

      </> : ''}

      {getGlobalUser.isLoggedIn && getGlobalIsRegistered ? <>
        <div className="login__ok">
          <h2>{ ask__('Login: Success') }</h2>
        </div>
      </> : ''}


    </div>
  )

}
